<app-ion-common-header [id]="headerId" (backHeader)="back()" [title]="titlePage"></app-ion-common-header>
<ion-content [attr.aria-hidden]="ariaHidden">
  <app-ion-common-retry
    [headerId]="headerId"
    (sendEventRetry)="tryAgain()"
  >
  </app-ion-common-retry>
</ion-content>